import application from 'application/application';
import moment from 'moment';

const controller = 'blockedUserController';

/* eslint-disable no-unused-vars */

application

	.controller(controller, ['$rootScope', '$scope', 'environment','$http', 'helper', 'API', ($rootScope, $scope, environment, $http, helper, API) => {
		$rootScope.attentionMsg = false;

		$rootScope.blockedPlatform = localStorage.getItem('__BlockedPlatform__');

		$rootScope.contracts = JSON.parse(localStorage.getItem('__contractsWithoutPay__'));

		$scope.navegatePayment = () => {
			localStorage.clear();
			sessionStorage.clear();
			window.location = 'https://pagamentos.advise.com.br';
		};

		($scope.checkUserContracts = () => {
			$http({
				...helper.http(API.contractsNew, 'GET'),
				params: {
					...helper.httpFields(['idSituacaoContrato', 'numero', 'dataProximoVencimento'])
				}
			})
			.then(response => {
				let contracts = response.data.itens;

				const findUserContracts = contracts.filter(
					item => item.idSituacaoContrato === -3 || item.idSituacaoContrato === -6
				);

				if (findUserContracts.length) {
					$scope.userContracts = contracts.map(item => ({
						idSituacaoContrato: item.idSituacaoContrato,
						numero: item.numero,
						dataProximoVencimento: item.dataProximoVencimento ? moment(new Date(item.dataProximoVencimento)).format('MMMM/DD') : ''
					}));
				}
			});
		})();
	}]);

export default controller;
